import { Tag } from 'antd';
import classNames from 'classnames';

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { getBrandById } from 'modules/brands/selectors';

/**
 * @typedef {{
 *  brandId: string,
 *  module?: string,
 *  showSuffixModule: boolean,
 *  allowDefaultValue?: boolean,
 * } & import('antd/lib/tag').TagProps} BrandTagProps
 */

/**
 * @param {BrandTagProps} props
 * @returns {React.FC<BrandTagProps>}
 */
const BrandTag = ({ brandId, className, module, showSuffixModule, allowDefaultValue = false, ...rest }) => {
  const brand = useSelector(state => getBrandById(state, brandId));
  const hasName = Boolean(brand?.name);
  const displayMode = Boolean(showSuffixModule && module);
  const displayTag = hasName || allowDefaultValue;

  return (
    displayTag && (
      <Tag {...rest} className={classNames(className, 'tag--status', 'default')}>
        {hasName && <span>{brand.name}</span>}
        {!hasName && <FormattedMessage id="defaultValue" defaultMessage="Default value" />}
        {displayMode && (
          <React.Fragment>
            <span className="ml-1 mr-1">-</span>
            <FormattedMessage id={module.toLowerCase()} defaultMessage={module.toLowerCase()} />
          </React.Fragment>
        )}
      </Tag>
    )
  );
};

export default BrandTag;
